module.exports = __webpack_public_path__ + "img/Dantam Hair 39.008923a7.jpg";